<script setup>
const route = useRoute()

const { data: source } = await useFetch(`/api/source/${route.params.id}`,
  { key: `s${route.params.id}` })
</script>

<template>
<v-container>
  <h2>{{ $t('Source') }} - <a :href="source?.link">{{ source?.name }}</a></h2>
  <AutoPostList
  :api="`/api/source/posts/${source.id}`"
  />
</v-container>
</template>
